export default {
  title: 'Beschikbaarheid aanpassen',
  amend_availabilities_form: {
    date: {
      label: 'Selecteer een datum',
    },
    times: {
      label: 'Diensten en openingstijden',
      description:
        'Definieer openingstijden voor de geselecteerde datum. Maak diensten langer, korter of blokkeer ze. Minstens één dienst moet open zijn.',
      breakfast: {
        label: 'Ontbijt',
      },
      lunch: {
        label: 'Lunch',
      },
      dinner: {
        label: 'Diner',
      },
    },
  },
  reason: {
    label: 'Voeg een reden toe (optioneel)',
    placeholder: 'Voer beschrijving in...',
  },
  buttons: {
    save: 'Opslaan',
  },
  projects: {
    online_shop: 'Online shop',
    reservations: 'Reserveringen',
    storefront: 'Storefront',
  },
  error_messages: {
    creation_failed: 'Aanmaken van uitzondering mislukt',
  },
};
